/* eslint-disable max-lines */

export const constantsData = {
    buttons: {
        account: "Account",
        activate: "Activate",
        add: "Add",
        apply: "Apply",
        approve: "Approve",
        audit: "Audit",
        auditLogs: "Audit Logs",
        back: "Back",
        backToLogin: "Back to Login",
        billing: "Billing",
        browseToUpload: "Browse to upload",
        calculate: "Calculate",
        cancel: "Cancel",
        cancelMapping: "Cancel Mapping",
        category: "Category",
        clear: "Clear",
        clearAll: "Clear All",
        close: "Close",
        copyClipboard: "Copy Clipboard",
        create: "Create",
        createAccounts: "Create your Accounts",
        dataSource: "Data Source",
        deactivate: "Deactivate",
        delete: "Delete",
        deleteProfile: "Delete Profile",
        disable: "Disable",
        download: "Download",
        edit: "Edit",
        editCompany: "Edit Company",
        editPassword: "Edit Password",
        editProfile: "Edit Profile",
        enable: "Enable",
        entry: "Entry",
        export: "Export",
        forgetPassword: "Forget your Password?",
        generateApiKey: "Generate API Key",
        goToHome: "Go to Home",
        goToLogin: "Go to Login?",
        goToSignup: "Go to Signup?",
        haveProfile: "Already have a Profile?",
        inviteUser: "Invite User",
        login: "Log in",
        logout: "Logout",
        manage: "Manage",
        manualEntry: "Manual Entry",
        manualReconcile: "Manual Reconcile",
        mapStatusValue: "Map Status Value",
        mapSupportingFields: "Map Supporting Fields",
        metadata: "Metadata",
        moveTo: "Move to",
        moveToParent: "Move to Parent",
        newOrganization: "New Organization",
        newRule: "New Rule",
        next: "Next",
        notHaveProfile: "Don't have a Profile?",
        organization: "Organization",
        postToLedger: "Post to Ledger",
        privacyPolicy: "Privacy Policy",
        proceed: "Proceed",
        process: "Process",
        profile: "Profile",
        reconcile: "Reconcile",
        reconciliation: "Reconciliation",
        refresh: "Refresh",
        rejectMatch: "Reject Match",
        reset: "Reset",
        retry: "Retry",
        revert: "Revert",
        reviewAndProcess: "Review & Process",
        revoke: "Revoke",
        revokeKey: "Revoke Key",
        run: "Run",
        save: "Save",
        send: "Send",
        sendInvite: "Send Invite",
        sendPasswordResetEmail: "Send Password Reset Email",
        settings: "Settings",
        setup: "Setup",
        signup: "Signup",
        syncNow: "Sync Now",
        terms: "Terms of Service",
        transaction: "Transaction",
        transform: "Transform",
        tryAgain: "Try Again",
        unreconcile: "Unreconcile",
        update: "Update",
        upload: "Upload",
        user: "User",
        users: "Users",
        view: "View",
        viewAll: "View All",
        viewAudit: "View Audit",
        viewDetails: "View Details",
        viewLess: "View Less",
        viewRules: "View Rules",
        viewUploadedFile: "View Uploaded File",
        yesProceed: "Yes, Proceed",
    },
    forms: {
        accounts: {
            account: {
                balanceType: {
                    description: "Account Type reflect in the data view",
                    label: "Type",
                },
                category: {
                    description: "Account Category reflect in the data view",
                    label: "Category",
                },
                currency: {
                    description: "Account Currency reflect in the data view",
                    label: "Currency",
                },
                description: {
                    description: "Account description reflect in the data view",
                    label: "Description",
                },
                hierarchy: {
                    description: "Account Hierarchy reflect in the data view",
                    label: "Hierarchy",
                },
                name: {
                    description: "The unique name for this account (e.g., \"Stripe Payouts\").",
                    label: "Name",
                },
                number: {
                    description: "Account Number reflect in the data view",
                    label: "Account Number (Optional)",
                },
                parentAccount: {
                    description: "Parent Account for Sub Account",
                    label: "Parent Account",
                },
                startingBalance: {
                    description: "Account Starting Balance reflect in the data view",
                    label: "Starting Balance",
                },
                startingBalanceDate: {
                    description: "Account Balance Effective Date reflect in the data view",
                    label: "Balance Effective Date",
                    tooltip: "Add a starting balance value starting from ”0” to set Account’s balance effective date",
                },
                status: {
                    description: "Account Status reflect in the data view",
                    label: "Status",
                },
            },
            moveToParent: {
                account: {
                    description: "Select Parent Account",
                    label: "Account",
                },
            },
        },
        apiKeys: {
            create: {
                apiKey: {
                    label: "API Key",
                },
                apiSecret: {
                    label: "API Secret",
                },
            },
        },
        auth: {
            forgetPassword: {
                email: { label: "Email" },
            },
            login: {
                email: { label: "Email Address" },
                password: { label: "Password" },
            },
            resetPassword: {
                confirmPassword: { label: "Confirm New Password" },
                password: { label: "New Password" },
            },
            signup: {
                confirmPassword: { label: "Confirm Password" },
                email: { label: "Email" },
                fullName: { label: "Full Name" },
                password: { label: "Password" },
            },
            verifyAccount: {
                confirmPassword: { label: "Confirm Password" },
                email: { label: "Email Address" },
                fullName: { label: "Name" },
                password: { label: "Password" },
            },
        },
        dataSources: {
            calculate: {
                condition: { label: "Condition" },
                firstAmountType: { label: "Amount 1" },
                secondAmountType: { label: "Amount 2" },
            },
            categories: {
                category: {
                    description: {
                        description: "Category Description reflect in the data view",
                        label: "Description",
                    },
                    name: {
                        description: "Category Name reflect in the data view",
                        label: "Category",
                    },
                },
                moveToParent: {
                    category: {
                        description: "Select the Category to move the sub-category",
                        label: "Category",
                    },
                },
            },
            entry: {
                date: {
                    description: "Entry Date reflect in the data view",
                    label: "Date",
                },
                description: {
                    description: "Entry Description reflect in the data view",
                    label: "Description",
                },
            },
            moveToCategory: {
                category: { label: "Category" },
            },
            setup: {
                apiConnection: {
                    account: {
                        description: "Select the account to integrate data source with",
                        label: "Account",
                    },
                    name: {
                        description: "Name of your data source",
                        label: "Data Source Name",
                    },
                    type: {
                        description: "Choose the type of your data source",
                        label: "Data Source Type",
                    },
                },
                offline: {
                    name: {
                        description: "Name of your data source",
                        label: "Data Source Name",
                    },
                    sourceFile: {
                        description: "Browse or drag your local file and upload to start mapping",
                        label: "Upload Source File",
                    },
                    type: {
                        description: "Choose the type of your data source",
                        label: "Data Source Type",
                    },
                },
                online: {
                    account: {
                        description: "Select the account to integrate data source with",
                        label: "Account",
                    },
                    frequency: {
                        description: "Data Source Sync Frequency reflect in the data view",
                        label: "Sync Frequency",
                    },
                    name: {
                        description: "Name of your data source",
                        label: "Name",
                    },
                },
            },
            transform: {
                amount: {
                    creditColumn: {
                        description: "Select the Credit Column to apply the Transformation",
                        label: "Credit Column",
                    },
                    creditValues: {
                        description: "Select the Credit Values to apply the Transformation",
                        label: "Credit Values",
                    },
                    dataAction: {
                        description: "Select the Data Action to apply the Transformation",
                        label: "Select Action",
                    },
                    dataType: {
                        description: "Select the Data Type to apply the Transformation",
                        label: "Select Type",
                    },
                    debitColumn: {
                        description: "Select the Debit Column to apply the Transformation",
                        label: "Debit Column",
                    },
                    debitValues: {
                        description: "Select the Debit Values to apply the Transformation",
                        label: "Debit Values",
                    },
                    isFractionalUnit: {
                        description: "Enable this if your uploaded data represents amounts in minor currency units (e.g., cents or piasters) rather than full units. For example, 100 = $1.00.",
                        label: "Raw Amounts are in Minor Units",
                    },
                },
                dateTime: {
                    dataAction: {
                        description: "Select the Data Action to apply the Transformation",
                        label: "Action",
                    },
                    date: {
                        description: "Select Raw Data Column",
                        label: "Date",
                    },
                    dateFormat: {
                        description: "Select Raw Data Date Format",
                        label: "Date Format",
                    },
                    hasTime: {
                        label: "Raw Data Has Time",
                    },
                    time: {
                        description: "Select Raw Data Time Column",
                        label: "Time",
                    },
                    timeFormat: {
                        description: "Select Raw Data Time Format",
                        label: "Raw Data Time Format",
                    },
                    timeZone: {
                        description: "Select Raw Data Time Zone",
                        label: "Raw Data Time Zone",
                    },

                },
                name: {
                    dataAction: {
                        description: "Select the Data Action to apply the Transformation",
                        label: "Action",
                    },
                    nameSeparator: {
                        description: "Select the Separator to apply the Transformation",
                        label: "Separator",
                    },
                },
                transactionId: {
                    defaultValue: {
                        description: "Select the Default Value to apply the Transformation",
                        label: "Default Value",
                    },
                },
            },
        },
        filters: {
            ACCOUNT: {
                category: { label: "Category" },
                currency: { label: "Currency" },
                date: { label: "Date" },
                status: { label: "Status" },
                type: { label: "Type" },
            },
            DATA_SOURCE: {
                connectionType: { label: "Connection Type" },
                currency: { label: "Currency" },
                status: { label: "Status" },
                type: { label: "Type" },
            },
            DATA_SOURCE_AUDIT_LOG: {
                date: { label: "Date" },
            },
            ORGANIZATION: {
                status: { label: "Status" },
                subscriptionPlan: { label: "Subscription Plan" },
            },
            ORGANIZATIONS_ENTRIES: {
                date: { label: "Date Range" },
                organization: { label: "Organization" },
                windowSize: { label: "Window Size" },
            },
            RECONCILIATION: {
                dataSource: { label: "Data Sources" },
                date: { label: "Last Sync Range" },
                status: { label: "Status" },
            },
            RECONCILIATION_AUDIT_LOG_MATCHING_TRANSACTION: {
                amount: {
                    from: { label: "From" },
                    label: "Amount Range",
                    to: { label: "To" },
                },
                confidence: {
                    from: { label: "From" },
                    label: "Confidence Score Range",
                    to: { label: "To" },
                },
                date: { label: "Time Period" },
                rule: {
                    label: "Matching Rule",
                },
                settlementDelay: {
                    from: { label: "From" },
                    label: "Settlement Delay Range",
                    to: { label: "To" },
                },
                status: { label: "Status" },
            },
            TRANSACTION: {
                ACCOUNT: {
                    amount: {
                        from: { label: "From" },
                        label: "Amount Range",
                        to: { label: "To" },
                    },
                    balanceType: { label: "Type" },
                    dataSource: { label: "Data Source" },
                    dateRange: { label: "Date Range" },
                    status: { label: "Status" },
                },
                DATA_SOURCE: {
                    amountFrom: { label: "Amount From" },
                    amountTo: { label: "Amount To" },
                    date: { label: "Date Range" },
                    type: { label: "Type" },
                },
                ENTRY: {
                    amount: {
                        from: { label: "From" },
                        label: "Amount Range",
                        to: { label: "To" },
                    },
                    date: { label: "Date Range" },
                    status: { label: "Status" },
                    type: { label: "Type" },
                },
                LEDGER: {
                    accounts: { label: "Account/Sub-Account" },
                    amount: {
                        from: { label: "From" },
                        label: "Amount Range",
                        to: { label: "To" },
                    },
                    dataSources: { label: "Data Sources" },
                    dateRange: { label: "Date Range" },
                    status: { label: "Status" },
                },
                RECONCILIATION: {
                    amount: {
                        from: { label: "From" },
                        label: "Amount Range",
                        to: { label: "To" },
                    },
                    date: { label: "Date Range" },
                    status: { label: "Status" },
                    type: { label: "Type" },
                },
            },
            TRANSACTION_AUDIT_LOG: {
                action: { label: "Action" },
                date: { label: "Date Range" },
            },
            TRANSACTION_VERSION_LOG: {
                date: { label: "Date Range" },
            },
        },
        organizations: {
            organization: {
                businessType: { label: "Business Type" },
                city: { label: "City" },
                companyEmail: { label: "Company Email" },
                companyName: { label: "Company Name" },
                companyStructure: { label: "Company Structure" },
                companyWebsite: { label: "Company Website" },
                country: { label: "Country" },
                currency: { label: "Currency" },
                employees: { label: "Number of Employees" },
                firstName: { label: "First Name" },
                industrySector: { label: "Industry Sector" },
                lastName: { label: "Last Name" },
                operationRegion: { label: "Operation Region" },
                postalCode: { label: "Postal Code" },
                state: { label: "State/Province" },
                status: {
                    description: "Select the Status to apply for the organization",
                    label: "Status",
                },
                streetAddress: { label: "Street Address" },
                subscriptionPlan: { label: "Subscription Plan" },
                subscriptionType: {
                    description: "Select subscription type for the organization",
                    label: "Subscription Type",
                },
            },
        },
        profile: {
            edit: {
                email: {
                    description: "Email reflect in the data view",
                    label: "Email",
                },
                firstName: {
                    description: "First Name reflect in the data view",
                    label: "First Name",
                },
                lastName: {
                    description: "Last Name reflect in the data view",
                    label: "Last Name",
                },
                userName: {
                    description: "User Name reflect in the data view",
                    label: "User Name",
                },
            },
            password: {
                confirmPassword: {
                    description: "Confirm your New Password",
                    label: "Confirm Password",
                },
                newPassword: {
                    description: "Your New Password that you want to use to access the platform",
                    label: "New Password",
                },
                oldPassword: {
                    description: "Your Old Password that you use to access the platform",
                    label: "Old Password",
                },
            },
        },
        reconciliations: {
            reconciliation: {
                conScoreConfigurations: {
                    description: "Define the confidence score thresholds for auto-matching. Transactions scoring at or above Matched are approved, those below Exception are flagged, and the rest are sent for Review",
                    label: "Confidence Score Configurations",
                },
                dataSourceA: {
                    description: "Select the Data Source A to apply the Reconciliation",
                    label: "Data Source A",
                },
                dataSourceB: {
                    description: "Select the Data Source B to apply the Reconciliation",
                    label: "Data Source B",
                },
                exceptionConScoreThreshold: { label: "Exceptions" },
                frequency: {
                    description: "Reconciliation Frequency reflect in the data view",
                    label: "Run Frequency",
                },
                inReviewConScoreThreshold: { label: "In Review" },
                matchedConScoreThreshold: { label: "Matched" },
                name: {
                    description: "Reconciliation Name reflect in the data view",
                    label: "Name",
                },
                rules: {
                    description: "Reconciliation Matching Rules reflect in the data view",
                    label: "Matching Rules",
                },
            },
        },
        transactions: {
            transaction: {
                currency: {
                    description: "Transaction Currency reflect in the data view",
                    label: "Currency",
                },
                date: {
                    description: "Transaction Date reflect in the data view",
                    label: "Date",
                },
                description: {
                    description: "Transaction Description reflect in the data view",
                    label: "Description",
                },
                status: {
                    description: "Transaction Status reflect in the data view",
                    label: "Status",
                },
            },
        },
        users: {
            password: {
                password: {
                    description: "User Password used to access the platform. Use at least 6-12 characters for strong password",
                    label: "Password",
                },
            },
            user: {
                email: {
                    description: "Add Email for the invited user",
                    label: "Email Address",
                },
                firstName: {
                    description: "Add First Name for the invited user",
                    label: "First Name",
                },
                lastName: {
                    description: "Add Last Name for the invited user",
                    label: "Last Name",
                },
                role: {
                    description: "User Role reflect in the data view",
                    label: "Role",
                },
            },
        },
    },
    labels: {
        404: "404",
        above95: ">95%",
        account: "Account",
        accountCurrency: "Account Currency",
        accounts: "Accounts",
        action: "Action",
        actions: "Actions",
        active: "Active",
        activeAccounts: "Active Accounts",
        activeDataSources: "Active Data Sources",
        address: "Address",
        adminPanel: "Admin Panel",
        agreement: "By signing up, you agree to the",
        aiRecommendation: "AI Recommendation",
        aiRules: "AI Rules",
        aiSuggestions: "AI Suggestions",
        allowedDaySlip: "Settlement Delay",
        amount: "Amount",
        apiKey: "API Key",
        apiKeys: "API Keys",
        apiSecret: "API Secret",
        appliedProperty: "Applied Property",
        askAlfredAbout: "Ask Alfred about:",
        assistantName: "FinTech Modeling Assistant",
        audit: "Audit",
        averageConfidence: "Average Confidence",
        balance: "Balance",
        balanceEffectiveDate: "Balance Effective Date",
        bankTransaction: "Bank Transaction",
        belowConfidence: " Below Confidence",
        beta: "Beta",
        between85and95: "85-95%",
        businessDay: "business day",
        businessDays: "business days",
        businessType: "Business Type",
        calculated: "Calculated",
        cashIn: "Cash In",
        cashOut: "Cash Out",
        category: "Category",
        changeIn: "Change In",
        city: "City",
        companyName: "Company Name",
        completed: "Completed",
        con: "Con",
        conScore: "Con-Score",
        confidence: " Confidence",
        connected: "Connected",
        connectionType: "Connection Type",
        copied: "Copied",
        coreFieldsMapping: "Core Fields Mapping",
        createCategoryDescription: "you can add, edit data source category",
        createOrganizationDescription: "Create Organization to manage your data at NAYA platform",
        createdAT: "Created at",
        createdAt: "Created at:",
        creationDate: "Creation Date",
        credit: "Credit",
        creditAccount: "Credit Account",
        creditAccounts: "Credit Accounts",
        creditValues: "Credit Values",
        currency: "Currency",
        data: "Data",
        dataAction: "Data Action",
        dataFormat: "Data Format",
        dataPreview: "Data Preview",
        dataSource: "Data Source",
        dataSourceName: "Data Source Name",
        dataSourceProvider: "Data Source Provider",
        dataSources: "Data Sources",
        dataTransformationsPreview: "Data Transformations Preview",
        dataType: "Data Type",
        date: "Date",
        dateAndTime: "Date & Time",
        dateRange: "Date Range",
        dateTime: "Date-Time",
        debit: "Debit",
        debitAccount: "Debit Account",
        debitAccounts: "Debit Accounts",
        debitValues: "Debit Values",
        defaultValue: "Default Value",
        description: "Description",
        details: "Details",
        difference: "Difference",
        disConnected: "Disconnected",
        disabled: "Disabled",
        dragAndDropExcelCSV: "Drag & Drop CSV / Excel file here",
        editedBy: "Edited By",
        email: "Email",
        emailAddress: "Email Address",
        emailVerification: "Email Verification",
        employees: "Employees",
        enabled: "Enabled",
        endDate: "End Date",
        entries: "Entries",
        entryDetails: "Entry Details",
        error: "Error",
        errorMessage: "Error Message",
        exceptions: "Exceptions",
        exposure: "Exposure",
        failed: "Failed",
        feeAmount: "Fee Amount",
        fileName: "File Name",
        filterBy: "Filter By",
        filters: "Filters",
        fromYesterday: "from yesterday",
        grossAmount: "Gross Amount",
        hash: "#",
        hello: "Hello I'm",
        highConfidence: "High Confidence",
        history: "History",
        id: "ID",
        ignored: "Ignored",
        ignoredTransactions: "Ignored Transactions",
        inReview: "In Review",
        inactive: "Inactive",
        inactiveAccounts: "Inactive Accounts",
        inactiveDataSources: "Inactive Data Sources",
        industry: "Industry",
        inprogress: "In Progress",
        job: "Job",
        journalEntries: "Journal Entries",
        key: "Key",
        lastRun: "Last Run",
        lastRunDate: "Last Run Date",
        lastSync: "Last Sync",
        lastUpdate: "Last Update",
        ledger: "Account",
        lessThan85: "<85%",
        logo: "Logo",
        mapAndTransform: "Map & Transform",
        mapStatusValue: "Map Status Value",
        mapped: "Mapped",
        mappedTag: "Mapped Tag",
        mappedTo: "mapped to",
        match: "Match",
        matched: "Matched",
        matchedBy: "Matched by",
        matchedTransactions: "Matched Transactions",
        matches: "Matches",
        matchingProcessTimelineDescription: "The Reconciliation Matching timeline shows the main phases and milestones, highlighting how it fits into our overall data management plan.",
        matchingSource: "Matching Source",
        matchingStatus: "Matching Status",
        mediumConfidence: "Medium Confidence",
        message: "Message",
        metaKeywords: "NAYA, Finance, Accounts, Transactions, Audits, Data Source, Records, Money, Banks, Credit, Debit, Cards, Balance",
        metadata: "Metadata",
        minimumConfidence: "Minimum Confidence",
        minimumConfidenceForAutoMatch: "85% for auto-match",
        ms: "ms",
        name: "Name",
        nameSeparator: "Name Separator",
        nayaApis: "NAYA APIs",
        needReview: "Need Review",
        netAmount: "Net Amount",
        newTransactions: "New Transactions",
        newTransactionsValue: "New Transactions Value",
        noResults: "No Results",
        notProcessed: "Not Processed",
        numberOfMatches: "No. of Matches",
        offline: "Offline",
        onboarding: "Onboarding",
        online: "Online",
        organization: "Organization",
        organizationId: "Organization ID",
        organizationName: "Organization Name",
        organizations: "Organizations",
        otherTransactionIds: "Other References",
        overview: "Overview",
        partiallyMatched: "Partially Matched",
        password: "Password",
        pending: "Pending",
        pendingTransactions: "Pending Transactions",
        policy: "Policy",
        policyUsed: "Policy Used",
        posted: "Posted",
        postedTransactions: "Posted Transactions",
        preview: "Preview",
        primaryContact: "Primary Contact",
        processedRecords: "Processed Records",
        processingTime: "Processing Time",
        proofId: "Proof ID",
        rawData: "Raw Data",
        reconciled: "Reconciled",
        reconciliation: "Reconciliation",
        reconciliationJobs: "Reconciliation Jobs",
        reconciliationStatus: "Reconciliation Status",
        referenceId: "Reference ID",
        referenceTransaction: " Reference Transaction",
        regions: "Regions",
        relatedTransactions: "Related Transactions",
        remaining: "Remaining",
        restAsPreviewExample: "result as Preview example",
        review: "Review",
        reviewAndProcess: "Review & Process",
        reviewRequired: "Review Required",
        revoked: "Revoked",
        role: "Role",
        rows: "Rows",
        rowsPerPage: "Rows Per Page",
        rrnType: "RRN Type",
        rule: "Rule",
        runFrequency: "Run Frequency",
        running: "Running",
        search: "Search",
        seconds: "seconds",
        selectAccount: "Select Account",
        settingUp: "Setting Up",
        settlementWindow: "Settlement Window",
        show: "Show",
        showingItems: "Showing Items",
        showingOnly: "Showing only",
        signupDate: "Sign-up Date",
        source: "Source",
        sourceA: "Source A",
        sourceAExceptions: "Source A Exceptions",
        sourceB: "Source B",
        sourceBExceptions: "Source B Exceptions",
        stack: "Stack",
        startDate: "Start Date",
        startingBalance: "Starting Balance",
        status: "Status",
        statusMapping: "Status Mapping",
        stepOneOfFive5: "Step 1/5",
        structure: "Structure",
        subscriptionPlan: "Subscription Plan",
        subscriptionSetting: "Subscription Setting",
        supportingFieldsMapping: "Supporting Fields Mapping",
        suspended: "Suspended",
        syncFrequency: "Sync Frequency",
        tCount: "T-Count",
        thisItem: "This Item",
        time: "Time",
        timeZone: "Time Zone",
        to: "To",
        tolerance: "Tolerance",
        total: "Total",
        totalAccounts: "Total Accounts",
        totalCredit: "Total Credit",
        totalCreditAccounts: "Total Credit Accounts",
        totalCreditValue: "Total Credit Value",
        totalDataSources: "Total Data Sources",
        totalDebit: "Total Debit",
        totalDebitAccounts: "Total Debit Accounts",
        totalDebitValue: "Total Debit Value",
        totalJobs: "Total Jobs",
        totalLedgerEntries: "Total number of ledger entries in",
        totalMatchedValue: "Total Matched Value",
        totalSourceA: "Total Source A",
        totalSourceB: "Total Source B",
        totalTransactions: "Total Transactions",
        totalTransactionsProcessed: "Total Transactions Processed",
        totalTransactionsValue: "Total Transactions Value",
        totalTransactionsVolume: "Total Transactions Volume",
        totalUsers: "Total Users",
        transactionCount: "Transaction Count",
        transactionId: "Transaction ID",
        transactionLogs: "Transaction Logs",
        transactionMatching: "Transaction Matching",
        transactions: "Transactions",
        transformation: "Transformation",
        transformed: "Transformed",
        type: "Type",
        uniqueTransactionId: "Unique Transaction Reference",
        unmapped: "Unmapped",
        unmatched: "Unmatched",
        unreconciled: "Unreconciled",
        untransformed: "Untransformed",
        unverified: "Unverified",
        upTo: "Up to",
        uploadAndSetup: "Upload & Setup",
        uploadFile: "Upload File",
        uploadedFiles: "Uploaded Files",
        usage: "Usage",
        username: "User Name",
        users: "Users",
        value: "Value",
        verified: "Verified",
        version: "Version",
        website: "Website",
        welcome: "Welcome",
        windowSize: "Window Size",
        wrongFormat: "Wrong Format!",
        you: "You",
    },
    msgs: {
        acceptedFormats: "Formats accepted are CSV & Excel Files.",
        accessDenied: "You don't have access to view this Page.",
        accountCategoriesFetchFailed: "Failed to Fetch Account Categories.",
        accountCreated: "Account Created Successfully.",
        accountCreatedFailed: "Failed to Create Account.",
        accountDataSourcesFetchFailed: "Failed to Fetch Account Data Sources.",
        accountDeleted: "Account Deleted Successfully.",
        accountDeletedFailed: "Failed to Delete Account.",
        accountDisabled: "Account Disabled Successfully.",
        accountDisabledFailed: "Failed to Disable Account.",
        accountEdited: "Account Saved Successfully.",
        accountEditedFailed: "Failed to Save Account.",
        accountEnabled: "Account Enabled Successfully.",
        accountEnabledFailed: "Failed to Enable Account.",
        accountFetchFailed: "Failed to Fetch Account.",
        accountTransactionsFetchFailed: "Failed to Fetch Account Transactions.",
        accountTransactionsStatusFetchFailed: "Failed to Fetch Account Transactions Status.",
        accountVerified: "Account Verified Successfully.",
        accountVerifiedFailed: "Failed to Verify Account",
        accountsFetchFailed: "Failed to Fetch Accounts.",
        accountsSelectionsFetchFailed: "Failed to Fetch Accounts Selections.",
        accountsStatusFetchFailed: "Failed to Fetch Accounts Status.",
        activateUser: "This action will activate your user and switch its status to active.",
        activatingUser: "Activating User.",
        addEntries: "Add Entries for transaction reflect in the data view.",
        addEntry: "Add Entry for data source reflect in the data view.",
        addMetadata: "Add Metadata for transaction reflect in the data view.",
        alfred: {
            analyzing: "Alfred is analyzing...",
            chat: {
                context: {
                    msg1: "Please explain this",
                    msg2: "row and help me understand what I should know about it. Here are the details:",
                    msg3: "Context: I'm viewing the",
                    msg4: "page and want to understand this specific item better.",
                },
                instructions: "Suggest the most relevant financial operations based on this context: Ledger Overview, Reconciliations Results, Accounts Status, Data Sources Overview, Recent Reconciliations, Recent Data Sources",
                intro: "Hi! 👋 I'm Alfred, your NAYA Operations Support Agent. I can help you with Financial Operations, Data Analysis, and Platform Navigation.",
                placeholder: "Ask me about your Financial Operations...",
            },
            checkChatPanel: "Check the Chat Panel for Alfred's Explanation.",
            contextIndicator: {
                considerNewConversation: " - Consider starting a new conversation",
                contextWindowUsage: "Context Window Usage",
                maximum: "Maximum:",
                percentUsed: "% used",
                remaining: "Remaining:",
                tokens: "tokens",
                used: "Used:",
            },
            explanationError: "Error Explaining Row with Alfred",
            explanationFailed: "Failed to get Explanation from Alfred:",
            messageRoles: {
                assistant: "assistant",
                user: "user",
            },
            unAuth: "Please log in to use Alfred Features.",
        },
        allStatusesFieldDescription: "This field for all status columns mapped from the status field through the supporting fields step.",
        allTransactionsInheritPostedStatus: "All Transactions will inherit “Posted” status by default.",
        amountFieldDescription: "Total amount of the transaction. This is a crucial field for financial calculations and reporting.",
        amountFieldExceedLimit: "Amount field should not exceed 1 Tag.",
        apiKeyCreatedFailed: "Failed to Create API Key.",
        apiKeyInstructions: [
            "Copy this key immediately using the copy clipboard button.",
            "Save it in a secure location.",
            "Cannot be recovered - Refreshing or closing this page will make the key inaccessible, if lost before use, you must generate a new key",
        ],
        apiKeyRevokedFailed: "Failed to Revoke API Key.",
        apiKeyRevokedSuccessfully: "API Key Revoked Successfully.",
        apiKeysListFetchFailed: "Failed to Fetch API Keys List.",
        assistantResponse: "I am ready to create your accounts, please click on the \"Create your Accounts\" button below. It might take time to proceed and establish the accounts after your clicking the button.",
        automatedAIRule: "Active Rule: Automated AI",
        balanceEffectiveDate: "This is the cut-off date for transactions. Only transactions dated on or after this date will be posted to this account via datasource or manually.",
        balanceNotMatch: "Debit and Credit must be equal to each other.",
        calculatingOfflineDataSourceAmountField: "Calculating Offline Data Source Amount Field.",
        calculationDeleted: "Calculation Deleted Successfully.",
        calculationDeletedFailed: "Failed to Delete Calculation.",
        cancelOfflineMappingDataSourceSession: "This action will cancel your offline mapping data source session. If you want to continue your mapping session later, so please visit this link below.",
        changeSubscriptionSettings: "Change Status or Subscription Plan.",
        checkYourEmailToContinue: "Please check your email to continue.",
        chooseAmountCalculation: "Choose Amount Calculation Methods (+/-).",
        connectToExternalDataSources: "Connect to external data sources via API integration. Enter your API credentials  to establish a secure connection with third-party services.",
        connectToOnlineDataSources: "Connect to online data sources to access real-time information from external systems. Authenticate once and keep your data automatically synced.",
        connectedToDataSourceOrTransactionsError: "Account is connected to a Data Source or has Transactions.",
        createAccount: "Create a new account to represent a financial entity, like a bank account or revenue stream, in your ledger.",
        createCategory: "Create Category to manage your data at NAYA Platform.",
        createEntry: "Add Entry information so that can monitor and manage financial activity across all accounts at a NAYA.",
        createOrganization: "Create Organization to manage your data at NAYA Platform.",
        createReconciliation: "Configure a new job to match transactions between two data sources. Set matching rules and thresholds to automate the process.",
        createTransaction: "Manually create a new journal entry. Ensure that total debits equal total credits for a balanced transaction.",
        creatingAccount: "Creating Account.",
        creatingDataSourceCategory: "Creating Data Source Category.",
        creatingDataSourceEntry: "Creating Data Source Entry.",
        creatingManualReconciliation: "Creating Manual Reconciliation.",
        creatingOrganization: "Creating Organization.",
        creatingReconciliation: "Creating Reconciliation.",
        creatingTransaction: "Creating Transaction.",
        creatingUser: "Creating User.",
        currentlyReconciliationJob: "Reconciliation Job is currently.",
        dataMappingAndTransformation: "The field with (*) is mandatory, AI Mapped Recommendation can edits and transform.",
        dataSourceApiConnectionSetup: "Data Source API Connection Setup Successfully.",
        dataSourceApiConnectionSetupFailed: "Failed to Setup Data Source API Connection.",
        dataSourceAuditLogsFetchFailed: "Failed to Fetch Data Source Audit Logs.",
        dataSourceCategoriesFetchFailed: "Failed to Fetch Data Source Categories.",
        dataSourceCategoryCreated: "Data Source Category Created Successfully.",
        dataSourceCategoryCreatedFailed: "Failed to Create Data Source Category.",
        dataSourceCategoryDeleted: "Data Source Category Deleted Successfully.",
        dataSourceCategoryDeletedFailed: "Failed to Delete Data Source Category.",
        dataSourceCategoryEdited: "Data Source Category Saved Successfully.",
        dataSourceCategoryEditedFailed: "Failed to Save Data Source Category.",
        dataSourceCategoryFetchFailed: "Failed to Fetch Data Source Category.",
        dataSourceDeleted: "Data Source Deleted Successfully.",
        dataSourceDeletedFailed: "Failed to Delete Data Source.",
        dataSourceEntryCreated: "Data Source Entry Created Successfully.",
        dataSourceEntryCreatedFailed: "Failed to Create Data Source Entry.",
        dataSourceFetchFailed: "Failed to Fetch Data Source.",
        dataSourceSubCategoriesFetchFailed: "Failed to Fetch Data Source Sub-Categories.",
        dataSourceTypesFetchFailed: "Failed to Fetch Data Source Types.",
        dataSourcesFetchFailed: "Failed to Fetch Data Sources.",
        dataSourcesOverviewFetchFailed: "Failed to Fetch Data Sources Overview.",
        dataSourcesTransactionsFetchFailed: "Failed to Fetch Data Source Transactions.",
        dateTimeFieldDescription: "Date-Time field captures the exact date and time when the transaction occurred. This timestamp is essential for maintaining accurate records, auditing, and analyzing transaction patterns over time.",
        dateTimeFieldExceedLimit: "DateTime field should not exceed 2 Tags (must be 1 or 2 only).",
        deactivateUser: "This action will deactivate your user and switch its status to inactive.",
        deactivatingUser: "Deactivating User.",
        defaultConfidenceScoresNote: "Use Default Values for Confidence Score.",
        deleteAccount: "This action cannot be undone. This will permanently delete this Account and remove its data from our servers.",
        deleteDataSource: "This action cannot be undone. This will permanently delete this Data Source and its data from our servers.",
        deleteDataSourceCategory: "This action cannot be undone. This will permanently delete this Data Source Category and remove its data from our servers.",
        deleteOfflineMappingDataSourceSession: "This action cannot be undone. This will permanently delete this Offline Mapping Data Source Session and remove its data from our servers.",
        deleteProfile: "If you click delete my profile button, your Profile will be deleted from our Database permanently.",
        deleteUser: "This action cannot be undone. This will permanently delete this User and remove its data from our servers.",
        deletingAccount: "Deleting Account.",
        deletingCalculation: "Deleting Calculation.",
        deletingDataSource: "Deleting Data Source.",
        deletingDataSourceCategory: "Deleting Data Source Category.",
        deletingTransformation: "Deleting Transformation.",
        deletingUser: "Deleting User.",
        disableAccount: "This action will disable your account and switch its status to inactive. Disabling the account will restrict all actions across it, sub accounts if presented, connected data sources as well as creating reconciliation jobs.",
        disablingAccount: "Disabling Account.",
        dragTag: "Drag Tag Here",
        editAccount: "Edit account information so that can monitor and manage financial activity across all accounts at NAYA.",
        editCategory: "Edit Category to manage your data at NAYA Platform.",
        editProfile: "Change your personal information to reflect on the platform profile information.",
        editProfilePassword: "Change your Password to keep your security login the platform.",
        editReconciliation: "Edit Reconciliation to match transactions between two data sources and identify discrepancies. Configure matching rules, tolerance thresholds, and exception handling to automate the reconciliation process and ensure accurate financial reporting.",
        editUser: "Edit User information so that can customize account preferences, manage permissions, and enhance accessibility across financial accounts at NAYA.",
        editUserPassword: "Edit User password so that can customize account preferences, manage permissions, and enhance accessibility across financial accounts at NAYA.",
        editingDataSourceCategory: "Editing Data Source Category.",
        enableAccount: "This action will enable your account and switch its status to active.",
        enablingAccount: "Enabling Account.",
        enterEmailToResetPassword: "Enter your email address to reset your password.",
        enterYourCredentialsToLogin: "Enter your details to access your account.",
        entriesAlert: "Credit and Debit must be equal to each other.",
        exportFailed: "Failed to Export Data.",
        exportSuccess: "Data Export Process Started Successfully. You will receive an email with the data once the export is complete.",
        exportingData: "Exporting Data...",
        fileUploaded: "File Uploaded Successfully.",
        fileUploadedFailed: "Failed to Upload File.",
        forgetPasswordError: "Email doesn't exist in Database, Please Signup with this Email.",
        forgetPasswordFailed: "Failed to send password reset email.",
        forgetPasswordSuccess: "Password reset email sent.",
        generateNewApiKeyAlert: "Generating a new API key will **immediately revoke** your current key.Any existing integrations will stop working until you update them with the new credentials.\n Are you sure you want to proceed?",
        generatedApiKeys: "Generated APIs Keys List",
        getAdminOrganizationEntriesFailed: "Failed to Get Organization Entries.",
        getDataSourcesOverviewFailed: "Failed to Get Data Sources Overview.",
        getJobsOverviewFailed: "Failed to Get Jobs Overview.",
        getOrganizationDataSourcesOverviewFailed: "Failed to Get Organization Data Sources Overview.",
        getOrganizationJobsOverviewFailed: "Failed to Get Organization Jobs Overview.",
        getOrganizationSummaryFailed: "Failed to Get Organization Summary.",
        ignoreUnMappedValues: "Map Unmapped Values to (Ignored).",
        importDataFromLocalFiles: "Import data from local CSV files with interactive column mapping. preview the data structure, and map CSV columns to target fields.",
        invalidExtension: "Invalid File Extension.",
        invitationTokenValidatedFailed: "Failed to Validate User Invitation Token.",
        inviteUser: "Add more users by Inviting users to your organization.",
        jobsOverviewFetchFailed: "Failed to Fetch Jobs Overview.",
        lastMatchingAuditJobFetchFailed: "Failed to Fetch Last Matching Audit Job.",
        ledgerOverviewFetchFailed: "Failed to Fetch Ledger Overview.",
        ledgerTransactionEntriesCountsFetchFailed: "Failed to Fetch Ledger Transaction Entries Counts.",
        ledgerTransactionEntriesFetchFailed: "Failed to Fetch Ledger Transaction Entries.",
        ledgerTransactionEntryFetchFailed: "Failed to Fetch Ledger Transaction Entry.",
        ledgerTransactionFetchFailed: "Failed to Fetch Ledger Transaction.",
        ledgerTransactionsFetchFailed: "Failed to Fetch Ledger Transactions.",
        manualReconciliationCreated: "Manual Reconciliation Created Successfully.",
        manualReconciliationCreatedFailed: "Failed to Create Manual Reconciliation.",
        mapOfflineDataSource: "Configure and Map your Offline Data Source.",
        mapValuesTransactionStatuses: "Map values from the selected source data column to internal transaction statuses.",
        matchedDataSourcesFetchFailed: "Failed to Fetch Matched Data Sources.",
        metaDescription: "NAYA is A core financial product that helps businesses record, track, and manage all their financial transactions in real-time. It could be designed to handle high volumes of data and complex financial scenarios.",
        metadataFieldDescription: "Metadata field captures additional information about the transaction that may not fit into standard fields. This can include tags, notes, or custom attributes that provide context and aid in categorization and analysis.",
        minEntries: "Entries must be at least 2 entries.",
        minMetadata: "Metadata must be at least 1 metadata.",
        minPassword: "Password must be at least 6 characters.",
        missedRefreshToken: "Refresh Token is Missing.",
        missingEntry: "Missing Entry, please enter at least one entry.",
        moveDataSourceToCategory: "Move Data Source to Category or Sub-Category.",
        moveToParent: "Move your account to a parent account, your account will be sub account, so you can monitor and manage financial activity across all accounts at NAYA.",
        nameFieldDescription: "Name field is used to capture the name or title of the transaction. This field provides a brief description of the transaction, making it easier to identify and categorize.",
        noAccessToViewData: "You don’t have access to view this Data.",
        noApiKeysYet: "You don’t have any API Keys added yet, Generate API Key to be able to see the data",
        noDataYet: {
            ACCOUNT: "You don't have any Accounts added yet, add an Account to be able to see the data.",
            ADMIN_DATA_SOURCE: "There are no Integration Data Sources existed yet for this Category.",
            DATA_SOURCE: "You don't have any Data Source added yet, add a Data Source to be able to see the data.",
            DATA_SOURCE_AUDIT_LOG: "You don’t have any Data Source Audit Logs added yet, add a Data Source Audit Log to be able to see the data.",
            ENTRY: "You don’t have any Entries added yet, add an Entry to be able to see the data.",
            INTEGRATION_DATA_SOURCE: "There are no Integration Data Sources existed yet for this Type.",
            LEDGER: "You don’t have any Ledger Transactions added yet, add a Ledger Transactions to be able to see the data.",
            MATCHED_TRANSACTION: "You don’t have any Transactions matched yet, Add a Transaction to be able to see the data.",
            ORGANIZATION: "You don’t have any Organizations added yet, add an Organization to be able to see the data.",
            ORGANIZATIONS_ENTRIES: "You don’t have any Organization Entries added yet, add an Organization Entry to be able to see the data.",
            ORGANIZATION_ENTRIES: "You don’t have any Organization Entries added yet, add an Organization Entry to be able to see the data.", // eslint-disable-line
            PROFILE: "You don’t have any Profiles added yet, add a Profile to be able to see the data.",
            RECONCILIATION: "You don't have any Reconciliation added yet, add a Reconciliation to be able to see the data.",
            RECONCILIATION_AUDIT_LOG_MATCHING_TRANSACTION: "You don’t have any Reconciliation Audit Logs for Matching Transactions yet",
            TRANSACTION: "You don’t have any Transactions added yet, add an Transaction to be able to see the data.",
            TRANSACTION_AUDIT_LOG: "You don’t have any Transaction Audit Logs added yet, add a Transaction Audit Log to be able to see the data.",
            TRANSACTION_METADATA: "You don’t have any Metadata added yet, add a Metadata to be able to see the data.",
            TRANSACTION_VERSION_LOG: "You don’t have any Transaction Version Logs yet",
            USER: "You don’t have any Users added yet, add a User to be able to see the data.",
        },
        noTransformations: "No Transformation Yet",
        notFound: "Oooops, Seems like this link is broken.",
        notValidBalance: "Balance must be a Valid Integer or an Empty String.",
        notValidConfidenceScores: "Confidence Scores must follow: (Matched > In Review > Exceptions). Exceptions must be between 0 and 0.49, In Review must be between 0.5 and 1 & Matched must be between 0.8 and 1",
        notValidEmail: "Invalid Email.",
        offlineBankDataSourceAcceptOneAmountField: "Offline Bank Data Source can accept only one Amount field at a time (Net, Gross, or Fee).",
        offlineDataSourceAmountFieldCalculated: "Offline Data Source Amount Field Calculated Successfully.",
        offlineDataSourceFieldRrnTypesEditedFailed: "Failed to Save Offline Data Source Field RRN Types.",
        offlineDataSourceFieldTransformationFetchFailed: "Failed to Fetch Offline Data Source Field Transformation.",
        offlineDataSourceFieldTransformed: "Offline Data Source Field Transformed Successfully.",
        offlineDataSourceFieldTransformedFailed: "Failed to Transform Offline Data Source Field.",
        offlineDataSourceFieldsMappingEditedFailed: "Failed to Save Offline Data Source Fields Mapping.",
        offlineDataSourceFieldsMappingFetchFailed: "Failed to Fetch Offline Data Source Fields Mapping.",
        offlineDataSourcePostedToLedger: "Offline Data Source Posted to Ledger Successfully.",
        offlineDataSourcePostedToLedgerFailed: "Failed to Post Offline Data Source to Ledger.",
        offlineDataSourceProcessingSummaryFetchFailed: "Failed to Fetch Offline Data Source Processing Summary.",
        offlineDataSourceSetup: "Offline Data Source Setup Successfully.",
        offlineDataSourceSetupFailed: "Failed to Setup Offline Data Source.",
        offlineDataSourceStatusMappingEdited: "Offline Data Source Status Mapping Saved Successfully.",
        offlineDataSourceStatusMappingEditedFailed: "Failed to Save Offline Data Source Status Mapping.",
        offlineDataSourceTransactionsFileUploaded: "Offline Data Source Transactions File Uploaded Successfully.",
        offlineDataSourceTransactionsFileUploadedFailed: "Failed to Upload Offline Data Source Transactions File.",
        offlineDataSourceUploadedFileFetchFailed: "Failed to Fetch Offline Data Source Uploaded File.",
        offlineNetwork: "Your Internet connection is unstable, please try again later or try another network",
        onlineDataSourceSetup: "Online Data Source Setup Successfully.",
        onlineDataSourceSetupFailed: "Failed to Setup Online Data Source.",
        onlineDataSourceSynced: "Online Data Source Synced Successfully.",
        onlineDataSourceSyncedFailed: "Failed to Sync Online Data Source.",
        onlyAcceptCSVandXLSX: "Formats accepted are CSV, XLSX , or XLS.",
        organizationCreated: "Organization Created Successfully.",
        organizationCreatedFailed: "Failed to Create Organization.",
        organizationCurrenciesFetchFailed: "Failed to Fetch Organization Currencies.",
        organizationDataSourcesOverviewFetchFailed: "Failed to Fetch Organization Data Sources Overview.",
        organizationEdited: "Organization Saved Successfully.",
        organizationEditedFailed: "Failed to Save Organization.",
        organizationEntriesFetchFailed: "Failed to Fetch Organization Entries.",
        organizationFetchFailed: "Failed to Fetch Organization.",
        organizationJobsOverviewFetchFailed: "Failed to Fetch Organization Jobs Overview.",
        organizationSelectionsFetchFailed: "Failed to Fetch Organization Selections.",
        organizationSummaryFetchFailed: "Failed to Fetch Organization Summary.",
        organizationUsersFetchFailed: "Failed to Fetch Organization Users.",
        organizationsFetchFailed: "Failed to Fetch Organizations.",
        otherTransactionIdsFieldDescription: "Other references associated with the transaction, such as invoice numbers or payment references. These can aid in further identification and reconciliation.",
        overseeDataSourcesIntegrations: "Oversee the Integration of your Data Sources. Add, Manage, and View Connections.",
        partiallyReconciled: "Mark Expected Payment as Partially Reconciled.",
        passwordNotMatch: "Password didn't Match.",
        passwordReset: "Password Reset Successfully. Please log in with your new Credentials.",
        passwordResetFailed: "Password Reset Failed",
        passwordResetOnWay: "A Password Reset Link is on its Way.",
        passwordSent: "Password Reset Email Sent.",
        passwordSentFailed: "Failed to Send Password Reset Email.",
        passwordsDoNotMatch: "Passwords do not Match.",
        pendingStatusFieldDescription: "This field for pending status columns reflect in the data view.",
        postedStatusFieldDescription: "This field for posted status columns reflect in the data view. This field is mandatory to be mapped.",
        postingOfflineDataSourceToLedger: "Posting Offline Data Source to Ledger.",
        processingSummary: "This page summarizes the processing step.",
        processingSummaryNote: "Transactions dated prior to the balance effective date will not be posted to selected account, regardless of their status.",
        profileEdited: "Profile Saved Successfully.",
        profileEditedFailed: "Failed to Save Profile.",
        profileLoggedIn: "Logged In Successfully.",
        profileLoggedInFailed: "Failed to Login.",
        profileRegistered: "Registered Successfully.",
        providers: {
            alfredAgent: "useAlfredAgentContext must be used within AlfredAgentProvider.",
            alfredChat: "useAlfredChatContext must be used within AlfredChatProvider.",
            formField: "useFormFieldContext must be used within FormFieldProvider.",
            stepper: "useStepperContext must be used within StepperProvider.",
            stepperItem: "useStepperItemContext must be used within StepperItemProvider.",
            theme: "useThemeContext must be used within ThemeProvider.",
        },
        reconcileReconciliationJob: "This action cannot be undone. This will reconcile your Reconciliation Job.",
        reconciliationAuditLogConfidenceInsightsFetchFailed: "Failed to Fetch Reconciliation Audit Log Confidence Insights.",
        reconciliationAuditLogExecutionPlanFetchFailed: "Failed to Fetch Reconciliation Audit Log Execution Plan Overview.",
        reconciliationAuditLogOverviewFetchFailed: "Failed to Fetch Reconciliation Audit Log Overview.",
        reconciliationAuditLogRuleInsightsFetchFailed: "Failed to Fetch Reconciliation Audit Log Rule Insights.",
        reconciliationAuditLogRulesListFetchFailed: "Failed to Fetch Reconciliation Audit Log Rules List.",
        reconciliationAuditLogsFetchFailed: "Failed to Fetch Reconciliation Audit Logs.",
        reconciliationAuditLogsTransactionsFetchFailed: "Failed to Fetch Reconciliation Audit Logs Transactions.",
        reconciliationCreated: "Reconciliation Created Successfully.",
        reconciliationCreatedFailed: "Failed to Create Reconciliation.",
        reconciliationEdited: "Reconciliation Saved Successfully.",
        reconciliationEditedFailed: "Failed to Save Reconciliation.",
        reconciliationFetchFailed: "Failed to Fetch Reconciliation.",
        reconciliationJob: "Reconciliation Job is",
        reconciliationJobRun: "Reconciliation Job Run Successfully.",
        reconciliationJobRunFailed: "Failed to Run Reconciliation Job.",
        reconciliationMatchingTransactionRulesFetchFailed: "Failed to Fetch Reconciliation Matching Transaction Rules.",
        reconciliationResultsFetchFailed: "Failed to Fetch Reconciliation Results.",
        reconciliationTransactionsFetchFailed: "Failed to Fetch Reconciliation Transactions.",
        reconciliationUnmatched: "Transaction Unmatched Successfully.",
        reconciliationUnmatchedFailed: "Failed to Unmatch Transaction.",
        reconciliationsFetchFailed: "Failed to Fetch Reconciliations.",
        requiredField: "Please fill The Mandatory Field.",
        requiredParentAccount: "Parent ID is required when Account Hierarchy is SUB.",
        resetPasswordTokenValidatedFailed: "Failed to Validate Reset Password Token.",
        retryReconciliationJob: "This action cannot be undone. This will retry your Reconciliation Job.",
        revertingTransactionVersionLog: "Reverting Transaction Version Log.",
        revokeApiKeyConfirmation: "Are you sure you want to revoke this key?",
        revokeApiKeyDescription: "This action will **immediately and permanently**revoke this API key and secret.\n All integrations, applications, or scripts currently using these credentials will **fail**. This action cannot be undone.",
        revokedApiKeyAlert: "This action will **immediately and permanently** ?revoke this API key and secret.All integrations, applications, or scripts currently using these credentials will **fail**. This action cannot be undone.",
        runReconciliationJob: "This action cannot be undone. This will run your Reconciliation Job.",
        runningReconciliationJob: "Running Reconciliation Job.",
        savingAccount: "Saving Account.",
        savingProfile: "Saving Profile.",
        savingReconciliation: "Saving Reconciliation.",
        savingTransactionMetadata: "Saving Transaction Metadata.",
        savingUser: "Saving User.",
        sendUserPasswordResetEmail: "This action will send a password reset email to the user.",
        sendingUserPasswordResetEmail: "Sending User Password Reset Email.",
        setNewPassword: "Set your New Password.",
        settingDataSourceApiConnection: "Setting Data Source API Connection.",
        settingOfflineDataSource: "Setting Offline Data Source.",
        settingOnlineDataSource: "Setting Online Data Source.",
        setupDataSourceApiConnection: "Enable real-time data exchange between applications and systems, fostering seamless integration and expanded functionality.",
        setupOfflineDataSource: "Configure your data source offline to inject your ledger with fully customized and mapping data.",
        setupOnlineDataSource: "Name this connection and link it to a Naya account to begin the secure authentication process.",
        somethingWrong: "Something went wrong in the client side. Please try refreshing the page again.",
        standardFieldsConfigs: "Configurations to Standard Fields.",
        standardFieldsNote: "The field with (*) is mandatory. AI mapped field recommendation can edit and transform.",
        statusFieldDescription: "Status field indicates the current state of the transaction, such as pending, completed, or failed. This information is crucial for tracking the progress of transactions and managing workflows.",
        statusFieldExceedLimit: "Status field should not exceed 3 Tags (must be 1 or 2 or 3 only).",
        syncingOnlineDataSource: "Syncing Online Data Source.",
        tagAlreadyMapped: "Tag is already mapped to this section.",
        thisTransactionWasMatchedUsing: "This transaction was matched using",
        transactionAuditActionsFetchFailed: "Failed to Fetch Transaction Audit Actions.",
        transactionAuditLogsFetchFailed: "Failed to Fetch Transaction Audit Logs.",
        transactionCreated: "Transaction Created Successfully.",
        transactionCreatedFailed: "Failed to Create Transaction",
        transactionFetchFailed: "Failed to Fetch Transaction.",
        transactionMatchedFetchFailed: "Failed to Fetch Matched Transactions.",
        transactionMetadataEdited: "Transaction Metadata Saved Successfully.",
        transactionMetadataEditedFailed: "Failed to Save Transaction Metadata.",
        transactionMetadataFetchFailed: "Failed to Fetch Transaction Metadata.",
        transactionMetadataReverted: "Transaction Metadata Reverted successfully.",
        transactionRelatedFetchFailed: "Failed to Fetch Related Transactions.",
        transactionUnmatchedFetchFailed: "Failed to Fetch Unmatched Transactions.",
        transactionVersionLogFetchFailed: "Failed to Fetch Transaction Version Log.",
        transactionVersionLogsFetchFailed: "Failed to Fetch Transaction Version Logs.",
        transformDeleted: "Transformation Deleted Successfully.",
        transformationDeletedFailed: "Failed to Delete Transformation.",
        transformingOfflineDataSourceField: "Transforming Offline Data Source Field.",
        tryAgainLater: "Please try again later.",
        unexpectedErrorOccurred: "An unexpected error occurred.",
        uniqueTransactionIdFieldDescription: "A unique reference for the transaction, such as a transaction ID. This helps in tracking and reconciling transactions accurately.",
        uniqueTransactionIdFieldExceedLimit: "Unique Transaction ID field should not exceed 1 Tag.",
        unknownError: "An unknown error occurred.",
        unmatchReconciliation: "Are you sure you want to break this match? The transaction will be moved to exceptions for this reconciliation.",
        uploadedFileParsingError: "Error while parsing Uploaded File.",
        uploadingOfflineDataSourceTransactionsFile: "Uploading Offline Data Source Transactions File.",
        useItOnlyOnce: "Use it only once - after first use, the key will be invalidated.",
        userActivated: "User Activated Successfully.",
        userActivatedFailed: "Failed to Activate User.",
        userCreated: "User Created Successfully.",
        userCreatedFailed: "Failed to Create User.",
        userDeactivated: "User Deactivated Successfully.",
        userDeactivatedFailed: "Failed to Deactivate User.",
        userDeleted: "User Deleted Successfully.",
        userDeletedFailed: "Failed to Delete User.",
        userEdited: "User Saved Successfully.",
        userEditedFailed: "Failed to Save User.",
        userFetchFailed: "Failed to Fetch User.",
        userInvited: "User Invited Successfully.",
        userInvitedFailed: "Failed to Invite User.",
        userPasswordResetEmailSent: "User Password Reset Email Sent Successfully.",
        userPasswordResetEmailSentFailed: "Failed to Send User Password Reset Email.",
        userRoleAssignedFailed: "Failed to Assign User Role.",
        userRoleRemovedFailed: "Failed to Remove User Role.",
        usersFetchFailed: "Failed to Fetch Users.",
        verifyAccount: "Verify your Account Information and Set Password.",
        viewAndManageYourDataSource: "View and manage your Data Source.",
        viewAndManageYourOrganization: "View and manage your Organization.",
        viewAndManageYourOrganizations: "View and manage your Organizations.",
    },
    others: {
        chunkErrors: {
            codes: ["ERR_CHUNK_LOAD_FAILED"],
            messagePatterns: [
                /Loading chunk \d+ failed/i,
                /Failed to fetch dynamically imported module/i,
                /Importing a module .* failed/i,
                /dynamic import/i,
                /module script failed/i,
                /networkerror/i,
            ],
            names: [
                "ChunkLoadError",
                "TypeError",
            ],
            typeError: "TypeError",
        },
        mb: "mb",
        networkErrors: {
            codes: [
                "ERR_CHUNK_LOAD_FAILED",
                "ERR_INTERNET_DISCONNECTED",
                "ERR_NETWORK",
            ],
            messagePatterns: [
                /Loading chunk \d+ failed/i,
                /Failed to fetch dynamically imported module/i,
                /Importing a module .* failed/i,
                /dynamic import/i,
                /module script failed/i,
                /networkerror/i,
                /net::err_internet_disconnected/i,
                /err_internet_disconnected/i,
                /failed to fetch/i,
                /network error/i,
            ],
            names: [
                "ChunkLoadError",
                "AxiosError",
            ],
            typeError: "TypeError",
        },
        parentIdNull: "00000000-0000-0000-0000-000000000000",
    },
    titles: {
        accountDetails: "Account Details",
        accountInfo: "Account Info",
        accountStatus: "Account Status",
        accountVerification: "Account Verification",
        accounts: "Accounts",
        accountsActivity: "Accounts Activity",
        accountsOverview: "Accounts Overview",
        accountsStatus: "Accounts Status",
        addManualEntry: "Add Manual Entry",
        adminPanel: "Admin Panel",
        alfredInfo: "Alfred Info",
        allData: "All Data",
        allStatuses: "All Statuses",
        amountPreview: "Amount Preview",
        amountTransform: "Transform Amount",
        apiConnectionSetup: "API Connection Setup",
        apiKeys: "API Keys",
        areYouSure: "Are you absolutely sure?",
        auditDetails: "Audit Details",
        auditLog: "Audit Log",
        auditLogs: "Audit Logs",
        categories: "Categories",
        changePassword: "Change Password",
        changeSubscriptionSettings: "Change Subscription Settings",
        checkYourEmail: "Check Your Email",
        companyAddress: "Company Address",
        companyInfo: "Company Info",
        companyInformation: "Company Information",
        completeAccountInfo: "Complete Account Info",
        connectedDataSources: "Connected Data Sources",
        coreFieldsMapping: "Core Fields Mapping",
        createAccount: "Create Account",
        createApiKey: "Create API Key",
        createCalculation: "Create Calculation",
        createCategory: "Create Category",
        createEntry: "Create Entry",
        createOrganization: "Create Organization",
        createReconciliation: "Create Reconciliation",
        createTransaction: "Create Transaction",
        createUser: "Create User",
        dashboard: "Dashboard",
        dataMappingAndTransformation: "Data Mapping & Transformation",
        dataSourceAuditLogs: "Data Source Audit Logs",
        dataSourceCategoryInfo: "Data Source Category Info",
        dataSourceDetails: "Data Source Details",
        dataSourceInfo: "Data Source Info",
        dataSources: "Data Sources",
        dataSourcesOverview: "Data Sources Overview",
        dataSourcesStatus: "Data Sources Status",
        datasetClassificationInfo: "Dataset Classification Info",
        dateTime: "Date Time",
        dateTimePreview: "DateTime Preview",
        dateTimeTransform: "Transform DateTime",
        editAccount: "Edit Account",
        editCalculation: "Edit Calculation",
        editCategory: "Edit Category",
        editProfile: "Edit Profile",
        editReconciliation: "Edit Reconciliation",
        editUser: "Edit User",
        editUserPassword: "Edit User Password",
        entries: "Entries",
        entry: "Entry",
        excludedMetadata: "Excluded Metadata",
        exportInfo: "Export Info",
        forgetPassword: "Forget Password",
        forgetPasswordInfo: "Forget Password Info",
        forgetYourPassword: "Forget Your Password ?",
        generateNewApiKey: "Generate New API Key ?",
        inviteUser: " Invite User",
        journalEntries: "Journal Entries",
        lastRunOverview: "Last Run Overview",
        ledger: "Ledger",
        ledgerInfo: "Ledger Info",
        ledgerOverview: "Ledger Overview",
        login: "Login",
        loginInfo: "Login Info",
        loginToAdminPanel: "Login to Admin Panel",
        loginToNaya: "Login to NAYA",
        mapValuesTransactionStatuses: "Map Values to Transactions Statuses",
        matchingProcessTimeline: "Matching Process Timeline",
        metadata: "Metadata",
        moveDataSource: "Move Data Source",
        moveToParent: "Move to Parent Account",
        namePreview: "Name Preview",
        nameTransform: "Transform Name",
        naya: "NAYA",
        nayaAdminPanel: "NAYA Admin Panel",
        nayaApisConnection: "NAYA APIs Connection",
        nayaAssistant: "NAYA Assistant",
        notFound: "Page Not Found",
        offlineDataSource: "Offline Data Source",
        offlineMappingDataSource: "Offline Mapping Data Source",
        offlineNetwork: "You are Offline",
        offlineSetup: "Offline Setup",
        onlineDataSource: "Online Data Source",
        onlineDataSourceCategories: "Online Data Source Categories",
        onlineNetwork: "You are Online",
        onlineSetup: "Online Setup",
        operationInfo: "Operation Info",
        organizationDetails: "Organization Details",
        organizationInfo: "Organization Info",
        organizations: "Organizations",
        overview: "Overview",
        pendingField: "Pending Field",
        postedField: "Posted Field",
        processingSummary: "Processing Summary",
        profile: "Profile",
        profileInfo: "Profile Info",
        recentDataSourcesStatus: "Most Recent Data Sources Status",
        recentReconciliationsStatus: "Most Recent Reconciliations Status",
        reconciliationDetails: "Reconciliation Details",
        reconciliationInfo: "Reconciliation Info",
        reconciliationJobs: "Reconciliation Jobs",
        reconciliationResults: "Reconciliation Results",
        reconciliationRule: "Reconciliation Rule",
        reconciliations: "Reconciliations",
        reconciliationsAudit: "Reconciliations Audit",
        reconciliationsOverview: "Reconciliations Overview",
        reconciliationsResults: "Reconciliations Results",
        reconciliationsStatus: "Reconciliations Status",
        resetPassword: "Reset Password",
        resetPasswordInfo: "Reset Password Info",
        rrnTypeMapping: "RRN Type Mapping",
        security: "Security",
        setupDataSource: "Setup Data Source",
        setupDataSourceApiConnection: "Setup Data Source Via Naya APIs",
        setupOfflineDataSource: "Setup Offline Data Source",
        setupOnlineDataSource: "Setup Online Data Source",
        signup: "Signup",
        signupInfo: "Signup Info",
        sourceA: "Source A",
        sourceB: "Source B",
        standardFields: "Standard Fields",
        statusMapping: "Status Mapping",
        subCategories: "Sub Categories",
        supportingFieldsMapping: "Supporting Fields Mapping",
        transactionDetails: "Transaction Details",
        transactionInfo: "Transaction Info",
        transactions: "Transactions",
        transactionsOverview: "Transactions Overview",
        uploadedFileData: "Uploaded File Data",
        userInfo: "User Info",
        userProfile: "User Profile",
        users: "Users",
        verifyAccountInfo: "Verify Account Info",
        versionHistory: "Version History",
        versionLogs: "Version Logs",
        whyThisMatched: "Why This Matched:",
    },
};
